import { render, staticRenderFns } from "./ProfileBlock.vue?vue&type=template&id=3852510e&scoped=true"
import script from "./ProfileBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBlock.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileBlock.vue?vue&type=style&index=0&id=3852510e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852510e",
  null
  
)

export default component.exports